import { URLS } from '../../../consts/endpoints';
import { postData } from '../../../utils/http';
import RESPONSE_CODES from '../../../consts/responseCodes';
import moment from 'moment';
import { isArray, isUndefined, isObject } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

const activateAction = async ({
  values,
  template,
  accountReference,
  clientId,
  product,
  clientName
}) => {
  const { code, attributes } = template;

  const product_characteristics = attributes.reduce((arr, att) => {
    const { name, label, valueType } = att;
    if (valueType === 'Date') {
      return [
        ...arr,
        {
          name,
          label,
          value: moment(values[label]).isValid()
            ? moment(values[label]).format('yyyy-MM-DD')
            : values[label]
        }
      ];
    }
    return [...arr, { name, label, value: values[label] }];
  }, []);

  let requestCompleted = {};

  const foundedPrice =
    product?.prices.find(price => price.sku === product?.sku) || {};

  const dataToSend = {
    order_items: [
      {
        action: 'add',
        identifier: 'SUBSCRIPTION',
        account_reference: accountReference,
        product_characteristics,
        product_offering: {
          sku: product?.sku,
          name: product?.name
        },
        product_price: {
          currency: foundedPrice.currency || 'DKK',
          setup: {
            price: foundedPrice.setupPrice || '0'
          },
          recurring: {
            price: foundedPrice.price || '0',
            period: 'MONTH'
          }
        },
        template_code: code
      }
    ],
    related_party: { id: clientId, name: clientName }
  };

  try {
    const response = await postData({
      url: URLS.PRODUCT_ORDERS,
      passErrors: true,
      data: {
        ...dataToSend
      }
    });

    if (response.status === RESPONSE_CODES.CREATED) {
      requestCompleted = {
        success: true
      };
    }
  } catch (e) {
    requestCompleted = {
      error: mapErrorResponse(e?.response?.data?.errors)
    };
  } finally {
    return requestCompleted;
  }
};

export default activateAction;

const mapErrorResponse = errorResponse => {
  if (isUndefined(errorResponse) || !isArray(errorResponse)) {
    return '';
  }

  return errorResponse
    .map(err => {
      if (isObject(err)) {
        return Optional(err.detail).or('');
      }
      return JSON.stringify(err);
    })
    .join(', ');
};
